var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 50,
    viewBox: "0 0 233 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 25C231.5 26.2187 230.931 27.5521 229.548 29.0032C228.158 30.4608 226.033 31.9391 223.166 33.3934C217.438 36.2997 209.051 38.9604 198.563 41.2111C177.612 45.707 148.598 48.5 116.5 48.5C84.4025 48.5 55.388 45.707 34.4368 41.2111C23.9489 38.9604 15.5621 36.2997 9.83383 33.3934C6.96738 31.9391 4.84239 30.4608 3.45243 29.0032C2.06869 27.5521 1.5 26.2187 1.5 25C1.5 23.7813 2.06869 22.4479 3.45243 20.9968C4.84239 19.5392 6.96738 18.0609 9.83383 16.6066C15.5621 13.7003 23.9489 11.0396 34.4368 8.78894C55.388 4.29297 84.4025 1.5 116.5 1.5C148.598 1.5 177.612 4.29297 198.563 8.78894C209.051 11.0396 217.438 13.7003 223.166 16.6066C226.033 18.0609 228.158 19.5392 229.548 20.9968C230.931 22.4479 231.5 23.7813 231.5 25Z",
    stroke: "url(#paint0_radial)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-56 25) rotate(27.9103) scale(114.295 518.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse4);
export default __webpack_public_path__ + "static/media/Ellipse4.566ce65572d94d669102e59d697d3852.svg";
export { ForwardRef as ReactComponent };